import { render, staticRenderFns } from "./pagesTable.vue?vue&type=template&id=178b8bc6&"
import script from "./pagesTable.vue?vue&type=script&lang=js&"
export * from "./pagesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports